// extracted by mini-css-extract-plugin
export var orderDetails = "_um-2";
export var orderImage = "_um-1";
export var orderMeta = "_um-3";
export var orderSummary = "_um-0";
export var rightArrow = "_um-4";